module.exports = __webpack_public_path__ + "img/input-check-correct.bd2ddf11.svg";